import 'react-app-polyfill/stable';
import configureStore from './redux/store';
import newService from './services';
import { render, destroy } from './Root';
import { destroyApp, renderApp } from './redux/actions/app/initialization';
import { setIsBaseParamsSetUpSelector } from './redux/reducers/app/initialization';
import {
  containerSelector,
  languageSelector,
} from './redux/reducers/app/params';
import { getHistory } from './services/history';

let store = null;

/**
 * Returns listener, which should render or destroy app, base on "state.app.isRendered" prop
 * @param store - Application store
 * @returns {Function} - Actual listener, for store change
 */
function handleStoreChange(store) {
  let shouldRender = false;

  return () => {
    const state = store.getState();
    const previousShouldRender = shouldRender;
    shouldRender = setIsBaseParamsSetUpSelector(state);

    if (previousShouldRender !== shouldRender) {
      if (shouldRender) {
        /**
         * Render phase
         */
        const container = containerSelector(state);
        const language = languageSelector(state);
        const history = getHistory();
        render(store, container, history, language);
      } else {
        /**
         * Destroy phase
         */
        destroy();
      }
    }
  };
}

/**
 * Registered hook
 */
newService.onRegistered(() => {
  // It's possible to start run saga middleware here or in onInitialized hook
  store = configureStore();

  store.subscribe(handleStoreChange(store));
});

/**
 * Render hook
 */
newService.onRender(() => {
  store.dispatch(renderApp());
});

/**
 * Destroy hook
 */
newService.onDestroy(() => {
  store.dispatch(destroyApp());
});

export { newService };
